module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "id": "page_i"
    }
  }), _c('a', {
    attrs: {
      "id": "otherfm"
    }
  }), _vm._v("Praise for "), _c('em', [_vm._v("The Devil Tree:")])]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("“Flawless . . . A strong, meaningful voice, adding something vital to the riches of the modern novel.”")]), _vm._v(" "), _c('p', {
    staticClass: "right1"
  }, [_vm._v("—"), _c('em', [_vm._v("The Times")]), _vm._v(" (London)")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("“One of our finest and most important writers . . . masterful.”")]), _vm._v(" "), _c('p', {
    staticClass: "right1"
  }, [_c('em', [_vm._v("—The Oregonian")]), _vm._v(" (Portland)")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("“Kosinski is, one is sure, related in some crazy way to Hesse. . . . An unusual writer—so consistently faithful to his own peculiar talent.”")]), _vm._v(" "), _c('p', {
    staticClass: "right1"
  }, [_c('em', [_vm._v("—Cincinnati Enquirer")])]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("“Jerzy Kosinski’s prose is in itself so remarkable—terse and hardedged but still supple and fluid—that it seems impossible he could ever fail or bore his readers. . . . Kosinski is one of our most valuable and exciting writers, and "), _c('em', [_vm._v("The Devil Tree")]), _vm._v(" will undoubtedly find a wide and appreciative audience.”")]), _vm._v(" "), _c('p', {
    staticClass: "right1"
  }, [_vm._v("—"), _c('em', [_vm._v("Saturday Review")])]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("“Stunning . . . powerful and affecting.”")]), _vm._v(" "), _c('p', {
    staticClass: "right1"
  }, [_c('em', [_vm._v("—Publishers Weekly")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_ii"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-afe06e2e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/otherfm.vue
// module id = 63
// module chunks = 0